import * as types from '../constants';

let initialState = {
  sideNav: false,
  filterIsVisible: false,
  modal: {},
  profileNav: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SIDENAV:
      return {
        ...state,
        sideNav: payload,
      };
    case types.FILTER:
      return {
        ...state,
        filterIsVisible: payload,
      };
    case types.MODAL:
      return {
        ...state,
        modal: {
          ...payload,
        },
      };
    case types.PROFILE_NAV:
      return {
        ...state,
        profileNav: payload,
      };
    default:
      return state;
  }
};

export default reducer;
